// Откуда был выбран магазин, из карты или списка
// Event дожен эммититься после SetShopId
export enum SetShopIdEventType {
  Map = 'Map',
  List = 'List',
}
